import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { createValidationObject } from '../../../redux/utils';
import { makeStyles } from "@material-ui/core";
import { RealForm } from "./RealForm";
import { FakeForm } from "./FakeForm";
import { DetailsForm } from './DetailsForm';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 100,
    color: '#fff',
    opacity: 1,
    backgroundColor: "#000000"
  },
}));

export const Form = (props) => {

  //console.log(props);

  const { id, cancel, config, editForm, addForm, loaded, loadedProcessed, data, getTable, getEnum, onChangeConfirm, getSchema, addItem, editItem, removeItem, keyValues } = props;
  const [ internalLoaded, setInternalLoaded ] = useState(false);
  const validationSchema = createValidationObject({fields: props.config.fields});

  const [reload, setReload] = useState(false);


  useEffect(() => {
    setReload(true);
    //console.log("EDIT ID", id)
    const fn = id ? ()=>editForm(id) : addForm;
    //cancel();
    fn()
      .then(response => {
        setReload(false);
      })
      .catch(error=> {
      });
  }, [ id, editForm, addForm ])

  useEffect(() => {
    if(loaded){
      loadedProcessed()
      setInternalLoaded(true); 
    }
  }, [loaded])

  const xData = useMemo(()=>({...data, getTable, getEnum, getSchema, addItem, editItem, removeItem, keyValues}), [data, getTable, getEnum, getSchema, addItem, editItem, removeItem, keyValues])

  return (
    <>
      {(!reload && internalLoaded) && 
        ((!config.policy.edit && id) || (!config.policy.add && !id)) && <DetailsForm {...{...props, id, validationSchema, data: xData, onChangeConfirm }}/>}
      {(!reload && internalLoaded) && 
        ((config.policy.edit && id) || (config.policy.add && !id)) && <RealForm {...{...props, id, validationSchema, data: xData, onChangeConfirm }}/>}
      {!reload && !internalLoaded && <FakeForm {...props}/>}
    </>
  )
}


export default Form;

